/* eslint-disable comma-dangle */
/* eslint-disable camelcase */
import { server } from '@/infra/server'
import {
  DecryptedData,
  ObjMunicipio,
} from '@/store/Pinia/useDynamicForms.store'

type LoginParams = {
  username: string
  otp: string
  recaptcha_token: string
}

export type ProductResponseType = {
  idProduto: string
  nome: string
  idperfiliti?: string
}

export type VoucherParam = {
  voucher: string
  arsubdomain: string
  unidade?: string
  token: {
    sessionId: string
    sessionData: string
  }
  cnpj?: string
  produtos?: ProductResponseType[]
  hasRfb?: boolean
  sub?: string
  recaptcha_token?: string
}

export type ResponseLogin = {
  sessionData: string
  sessionId: string
  nome: string
}

type ProductResponse = {
  id: string
  isSSL: boolean
  sku: string | number
  ext_produto: string
}

export type QsaResponseData = {
  razao_social?: string
  produto_financeiro?: boolean
}

export type ResponseLoginVoucher = {
  voucher: string
  nomeProduto: string
  produto: ProductResponse
  isBird: boolean
  isPj: boolean
  isRFB: boolean
  idunidade: string
  sessionData: string
  sessionId: string
  municipios: ObjMunicipio[]
  cpf: string
  nome: string
  cei: string
  pis: string
  dataDecrypted?: DecryptedData
  qsaResponseData?: QsaResponseData
}

export type ResponseGetProductsByVoucher = {
  status: string
  produtos: ProductResponseType[]
  idProdutoIniciado: null | string | number
  renovacaoJaIniciada?: boolean
  consultarCnpjRfbOuQsa?: boolean
}

type CessTokenType = {
  sessionData: string
  sessionId: string
}

type ParamsGetProductsByVoucher = {
  voucher: string
  arsubdomain: string
  cessToken: CessTokenType
  recaptcha_token: string
}

type VoucherSproParams = {
  username: string
  otp: string
  arsubdomain: string
  data: {
    iv: string
    data: string
  }
  recaptcha_token: string
}

const loginController = {
  loginWithToken: async (
    iv: string,
    encryptedToken: string,
    order: string,
    arsubdomain: string,
    cnpj: string,
    idperfiliti?: string,
    idproduto?: string,
  ) => {
    const profileId = idperfiliti?.trim()
    const productId = idproduto?.trim()
    const request = {
      access_token: {
        iv,
        encrypted_token: encryptedToken,
      },
      voucher: order,
      arsubdomain,
      cnpj,
      ...(profileId ? { idperfiliti: profileId } : {}),
      ...(productId ? { idproduto: productId } : {}),
    }

    const response = server.post<ResponseLoginVoucher>(
      'solicitation/create-with-token',
      request,
    )
    return response
  },
  login: async ({ username, otp, recaptcha_token }: LoginParams) => {
    const request = {
      username,
      otp,
      recaptcha_token,
    }
    const response = server.post<ResponseLogin>('just-auth', request)
    return response
  },
  validateVoucher: async (voucher: VoucherParam) => {
    const response = server.post<ResponseLoginVoucher>('login', voucher)
    return response
  },
  validateVoucherSPRO: async (params: VoucherSproParams) => {
    const response = await server.post<ResponseLoginVoucher>(
      'login-with-order-encrypted',
      {
        ...params,
      },
    )

    return response.data
  },
  getProductsByVoucher: async (params: ParamsGetProductsByVoucher) => {
    const { data: response } = await server.post<{
      message: ResponseGetProductsByVoucher
    }>('get-products-by-voucher', params)

    return { ...response.message }
  },
}

export default loginController
